import { render, staticRenderFns } from "./MandatResiliation.vue?vue&type=template&id=64e9ffdc"
import script from "./MandatResiliation.vue?vue&type=script&lang=js"
export * from "./MandatResiliation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports